import { z, type ZodObject, ZodRawShape } from 'zod';
/**
 * This function generates a mock object for a given schema, allowing for overrides.
 * @param schema The schema to generate a mock for
 * @param defaults The default values for the schema
 * @returns A function that takes overrides and resolves to the mocked object
 *
 * __NOTE: Schema must be a Zod object__
 *
 * @example
 * ```tsx
 * const mockResponse = generateMock(schema, { name: "John" });
 * // ...
 * const responseA = mockResponse();
 * const responseB = mockResponse({ name: "Jane" });
 * ```
 */
export const generateMock =
  <T extends ZodObject<ZodRawShape>>(schema: T, defaults: z.infer<T>) =>
  (overrides?: Partial<z.infer<T>>) => {
    return schema.default({ ...defaults, ...overrides }).parse(undefined);
  };
